var _line, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.0771,
    y1: 12,
    x2: 12.0771,
    y2: 21.0001,
    stroke: "#464646",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31273 21.6271L11.7212 23.7189L11.7252 23.7154L12.0529 24L14.7847 21.6274C15.2017 21.2653 15.2017 20.6781 14.7847 20.316L14.713 20.2536C14.296 19.8915 13.6199 19.8915 13.203 20.2536L12.0489 21.256L10.8945 20.2533C10.4775 19.8912 9.80144 19.8912 9.38447 20.2533L9.31273 20.3156C8.89576 20.6778 8.89576 21.2649 9.31273 21.6271Z",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6L21.2752 5.37281C20.613 5.13198 19.887 5.13198 19.2248 5.37281L18.5252 5.62719C17.863 5.86802 17.137 5.86802 16.4748 5.62719L15.7752 5.37281C15.113 5.13198 14.387 5.13199 13.7248 5.37281L13.0252 5.62719C12.363 5.86802 11.637 5.86802 10.9748 5.62719L10.2752 5.37281C9.61296 5.13199 8.88704 5.13199 8.22477 5.37281L7.52523 5.62719C6.86296 5.86802 6.13704 5.86802 5.47477 5.62719L4.77523 5.37281C4.11296 5.13199 3.38704 5.13199 2.72477 5.37281L1 6",
    stroke: "#464646",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepth);
export default __webpack_public_path__ + "static/media/depth.4e90294d9bd7410235fbc0c8d03b0f04.svg";
export { ForwardRef as ReactComponent };